/** Blurred casino room behind the table */
export default function CasinoRoomBackground() {
  return (
    <div className="tp-casino-room pointer-events-none absolute inset-0 z-0" aria-hidden>
      <div className="tp-casino-room-photo absolute inset-0" />
      <div className="tp-casino-room-gradient absolute inset-0" />
    </div>
  );
}
